let authGeneration = 0;
export function advanceAuthGeneration() { authGeneration++; }

export async function apiFetch(input, options = {}) {
  const base = new URL(process.env.API_URL, window.location.origin);
  const url = new URL(input, window.location.origin);
  const apiPath = `${base.pathname.replace(/\/$/, "")}/api/`;
  if (url.origin !== base.origin || !url.pathname.startsWith(apiPath)) return fetch(input, options);
  const headers = new Headers(options.headers);
  headers.delete("Authorization");
  headers.set("X-Requested-With", "XMLHttpRequest");
  const generation = authGeneration;
  const response = await fetch(input, { ...options, headers, credentials: "include" });
  if (generation === authGeneration && [402, 403].includes(response.status)) {
    const data = await response.clone().json().catch(() => null);
    if (["SECTION_PAYMENT_REQUIRED", "STORE_UNAVAILABLE"].includes(data?.code)) {
      window.dispatchEvent(new CustomEvent("community:access-denied", { detail: data }));
    }
  }
  if (generation === authGeneration && response.status === 401 && !url.pathname.endsWith("/auth/login") && !url.pathname.endsWith("/auth/signup")) {
    window.dispatchEvent(new Event("auth:expired"));
  }
  return response;
}
